<template>
    <AppLayout>
        <main class="flex grow flex-col items-center justify-center">
            <RouterView />
        </main>
        <AppFooter />
    </AppLayout>
</template>
